import SeekForward from '../assets/images/seek-forward.svg';
import SeekBackward from '../assets/images/seek-back.svg';

import "./seek-button.css";

const ButtonComponent = videojs.getComponent('Button');
let localize;

export class SeekButton extends ButtonComponent {
    constructor(player, options = {}) {
        localize = player.localize?.bind(player);

        const isForward = options.isForward;
        const name = isForward ? "SeekForwardButton" : "SeekBackButton";

        options.clickHandler = () => {
            player.currentTime(player.currentTime() + (options.seekDuration * ((isForward) ? 1 : -1)));
            this.announceButtonClick();  // For the screen reader log
        }

        super(player, Object.assign({ name: name }, options));
        this.activeText = localize(isForward ? 'Seeking Forward' : 'Seeking Back.');  // For the screen reader log
        this.addClass('mediasite-player__seek-button');
        this.addClass('mediasite-player__custom-controlbar-button');

        this.el().style.setProperty('--custom-controlbar-icon', `url("${(isForward) ? SeekForward : SeekBackward}")`);

        if (isForward) {
            this.controlText(localize(`Seek forward ${options.seekDuration} seconds (Right Arrow or Ctrl + Right Bracket)`));
        } else {
            this.controlText(localize(`Seek back ${options.seekDuration} seconds (Left Arrow or Ctrl + Left Bracket)`));
        }
    }
}